import { render, staticRenderFns } from "./EntryInfo.vue?vue&type=template&id=a0352640&scoped=true"
import script from "./EntryInfo.vue?vue&type=script&lang=js"
export * from "./EntryInfo.vue?vue&type=script&lang=js"
import style0 from "./EntryInfo.vue?vue&type=style&index=0&id=a0352640&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0352640",
  null
  
)

export default component.exports